var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options.length === 0
    ? _c("loader")
    : _c("property-base", {
        attrs: { label: _vm.label, icon: _vm.icon },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function(ref) {
              var id = ref.id
              return [
                _c(
                  "v-select",
                  {
                    staticClass: "form-control",
                    attrs: {
                      "input-id": id,
                      options: _vm.options,
                      clearable: false,
                      disabled: !_vm.canWrite,
                      searchable: "",
                      filterable: "",
                      taggable: "",
                      "close-on-select": ""
                    },
                    model: {
                      value: _vm.valueModel,
                      callback: function($$v) {
                        _vm.valueModel = $$v
                      },
                      expression: "valueModel"
                    }
                  },
                  [
                    _c("div", {
                      attrs: { slot: "no-options" },
                      slot: "no-options"
                    })
                  ]
                )
              ]
            }
          }
        ])
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }